import { useState } from 'react'

/**
 * useState that persists to localStorage.
 * Falls back to defaultValue if key is missing or unparseable.
 */
export function usePersistedState<T>(key: string, defaultValue: T): [T, (value: T | ((prev: T) => T)) => void] {
  const [state, setState] = useState<T>(() => {
    try {
      const stored = localStorage.getItem(key)
      return stored !== null ? JSON.parse(stored) : defaultValue
    } catch {
      return defaultValue
    }
  })

  function setAndPersist(value: T | ((prev: T) => T)) {
    setState(prev => {
      const next = typeof value === 'function' ? (value as (prev: T) => T)(prev) : value
      localStorage.setItem(key, JSON.stringify(next))
      return next
    })
  }

  return [state, setAndPersist]
}
